/** 首页模块模板注册表 — 前端维护，后端只存 key；picker.visible / picker.selectable 控制选择器展示与可选 */

export const CONTENT_SOURCE_TYPES = ['MENU', 'CONTENT_TYPE']
export const PRODUCT_SOURCE_TYPES = ['PRODUCT_CATEGORY']

export const HOME_TEMPLATES = [
  {
    key: 'FOCUS_CAROUSEL_LIST',
    name: '焦点轮播列表',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '左侧轮播焦点 + 右侧条目列表',
    picker: { visible: true, selectable: true },
  },
  {
    key: 'TAB_PANEL_SWITCH',
    name: '切换面板',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '大图 + 详情面板 + 底部 Tab 导航',
    picker: { visible: true, selectable: true },
  },
  {
    key: 'INTRO_CARD_GRID',
    name: '简介卡片',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '三列图文卡片 + 编号角标',
    picker: { visible: true, selectable: true },
  },
  {
    key: 'CATEGORY_PRODUCT_ROW',
    name: '分类产品展示',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '分类图标栏 + 横向产品卡片',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'CARD_GRID',
    name: '卡片网格',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '多列卡片网格，适合展示图文内容',
    picker: { visible: true, selectable: true },
  },
  {
    key: 'HORIZONTAL_LIST',
    name: '横向列表',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '横向排列条目，左侧缩略图 + 右侧文字',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'FEATURE_SIDE',
    name: '特色侧栏',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '左侧大图特色内容 + 右侧小列表',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'SLIDER',
    name: '横向动画',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '横向自动滚动展示，可调速，支持手动拖动',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'MASONRY_TEXT',
    name: '瀑布流（带标题简介）',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '不等高卡片瀑布流，含图片、标题与简介',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'MASONRY_COVER',
    name: '瀑布流（封面）',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '不等高封面图瀑布流，仅展示图片',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'TIMELINE',
    name: '时间轴',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '纵向时间线排列，适合新闻与动态',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'DUAL_COLUMN',
    name: '双列对比',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '左右两栏对比展示，适合并列信息',
    picker: { visible: false, selectable: false  },
  },
  {
    key: 'ICON_GRID',
    name: '图标宫格',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '小图标 + 文字宫格，适合快捷入口',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'HERO_BANNER',
    name: '大图横幅',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '全宽横幅重点展示，适合推广内容',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'ACCORDION',
    name: '手风琴折叠',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '折叠展开条目，适合 FAQ 或分类摘要',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'STATS_SHOWCASE',
    name: '数据亮点',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '大数字指标展示，适合成果与优势',
    picker: { visible: false, selectable: false  },
  },
  {
    key: 'NUMBERED_FEATURES',
    name: '编号优势',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '三列编号 + 图标 + 标题，适合核心优势展示',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'SPOTLIGHT_PANEL',
    name: '高亮分屏',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '左侧暗色视觉 + 右侧大标题与标签，适合方案/内容主推',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'ZIGZAG_FEATURE',
    name: '交错图文',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '图文左右交替 Z 字形排列，大留白',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'CHECKLIST_FEATURES',
    name: '特性清单',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '两列勾选图标 + 文案，适合能力服务清单',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'PILL_TAGS',
    name: '标签云',
    sourceTypes: CONTENT_SOURCE_TYPES,
    description: '圆角胶囊标签自由排布',
    picker: { visible: false, selectable: false  },
  },

  {
    key: 'CATEGORY_STACK',
    name: '分类分块',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '各分类独立标题 + 产品网格，纵向平铺',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'CATEGORY_SIDEBAR',
    name: '分类侧栏',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '左侧分类栏 + 右侧产品网格',
    picker: { visible: true, selectable: true  },
  },
  {
    key: 'CATEGORY_FEATURE_SPLIT',
    name: '主推分栏',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '左侧主打产品大图 + 右侧同分类产品列表',
    picker: { visible: true, selectable: true },
  },
  {
    key: 'CATEGORY_PORTAL_CARDS',
    name: '分类入口卡片',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '大图分类卡片，按全部一级分类展示，卡片内带全部下级链接',
    picker: { visible: true, selectable: true },
  },
  {
    key: 'CATEGORY_CAROUSEL',
    name: '产品轮播',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '横向滑动产品卡片，带预览露出',
    picker: { visible: false, selectable: false  },
  },
  {
    key: 'CATEGORY_BENTO',
    name: '产品便当盒',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '不规则网格突出主打产品',
    picker: { visible: false, selectable: false  },
  },
  {
    key: 'PRODUCT_COMPARE',
    name: '产品对比',
    sourceTypes: PRODUCT_SOURCE_TYPES,
    description: '表头 + 多列产品参数对比表',
    picker: { visible: false, selectable: false  },
  },
]

const DEFAULT_PICKER_CONFIG = { visible: false, selectable: true  }

const DEFAULT_BY_SOURCE = {
  MENU: 'FOCUS_CAROUSEL_LIST',
  CONTENT_TYPE: 'FOCUS_CAROUSEL_LIST',
  PRODUCT_CATEGORY: 'CATEGORY_PRODUCT_ROW',
}

/**
 * 每种模板的「舒适展示数量」。
 * 含义：在不出现滚动条的前提下，该模板一屏内适合展示的条目数量。
 * - 展示数量（displayCount）未设置或为 0（旧数据）时，前端按 default / 舒适数量回退；
 * - 当展示数量超过此上限时，多余条目仍会渲染，但会在该模板区域内出现滚动条。
 * 如需调整某个模板的默认/舒适数量，改这里即可。
 */
export const TEMPLATE_DISPLAY_LIMITS = {
  // —— 内容型 ——
  CARD_GRID: 6,
  HORIZONTAL_LIST: 5,
  FEATURE_SIDE: 4,
  SLIDER: 6,
  MASONRY_TEXT: 6,
  MASONRY_COVER: 6,
  TIMELINE: 5,
  DUAL_COLUMN: 6,
  ICON_GRID: 8,
  HERO_BANNER: 10,
  ACCORDION: 5,
  STATS_SHOWCASE: 4,
  NUMBERED_FEATURES: 3,
  SPOTLIGHT_PANEL: 1,
  ZIGZAG_FEATURE: 3,
  CHECKLIST_FEATURES: 6,
  PILL_TAGS: 10,
  FOCUS_CAROUSEL_LIST: 5,
  TAB_PANEL_SWITCH: 4,
  INTRO_CARD_GRID: 3,
  // —— 产品型 ——
  CATEGORY_STACK: 6,
  CATEGORY_SIDEBAR: 8,
  CATEGORY_FEATURE_SPLIT: 5,
  CATEGORY_CAROUSEL: 6,
  CATEGORY_BENTO: 5,
  PRODUCT_COMPARE: 3,
  CATEGORY_PRODUCT_ROW: 3,
  CATEGORY_PORTAL_CARDS: 6,
}

/** 自带区块标题栏的模板（预览用内置标题，不显示通用 header） */
export const PORTAL_TEMPLATES = [
  'FOCUS_CAROUSEL_LIST',
  'CATEGORY_PRODUCT_ROW',
  'CATEGORY_PORTAL_CARDS',
  'TAB_PANEL_SWITCH',
  'INTRO_CARD_GRID',
]

// 是否门户模板
export function isPortalTemplate(template) {
  return PORTAL_TEMPLATES.includes(resolveTemplateKey(template))
}

/** 默认舒适数量（未在表中登记的模板回退值） */
export const DEFAULT_DISPLAY_LIMIT = 6

/** 已下线模板 → 替代模板的映射（兼容旧数据预览） */
export const DEPRECATED_TEMPLATE_MAP = {
  MAGAZINE: 'FEATURE_SIDE',
  GLASS_CARDS: 'CARD_GRID',
  GRADIENT_CARDS: 'CARD_GRID',
  OVERLAY_CARDS: 'CARD_GRID',
  FLOATING_STRIP: 'SLIDER',
  IMAGE_MOSAIC: 'CARD_GRID',
  BENTO_GRID: 'CARD_GRID',
  QUOTE_SPOTLIGHT: 'CARD_GRID',
  NEON_DARK_GRID: 'CARD_GRID',
  MINIMAL_RANK: 'HORIZONTAL_LIST',
  PROCESS_STEPS: 'NUMBERED_FEATURES',
  SPLIT_SCREEN: 'SPOTLIGHT_PANEL',
  TICKER_STRIP: 'PILL_TAGS',
  PRODUCT_SHOWCASE_3D: 'CATEGORY_CAROUSEL',
  PORTAL_NEWS: 'FOCUS_CAROUSEL_LIST',
  PORTAL_PRODUCTS: 'CATEGORY_PRODUCT_ROW',
  PORTAL_SOLUTIONS: 'TAB_PANEL_SWITCH',
  PORTAL_ABOUT: 'INTRO_CARD_GRID',
  MASONRY: 'MASONRY_TEXT',
  CATEGORY_TABS: 'CATEGORY_PRODUCT_ROW',
}

/** 将旧 template key 解析为当前可用 key */
export function resolveTemplateKey(key) {
  if (!key) return key
  return DEPRECATED_TEMPLATE_MAP[key] || key
}

/** 获取某个模板的舒适展示数量 */
export function getTemplateDisplayLimit(template) {
  return TEMPLATE_DISPLAY_LIMITS[resolveTemplateKey(template)] || DEFAULT_DISPLAY_LIMIT
}

/**
 * 模板展示行为：弹性(flexible) vs 固定(fixed)。
 * - flexible：按「每分类数量」展示，超出舒适数量时在区域内滚动/换行
 * - fixed：只展示 count 条，多余忽略
 */
export const TEMPLATE_BEHAVIOR = {
  // —— 弹性（不限数量）——
  MASONRY_TEXT: { mode: 'flexible' },
  MASONRY_COVER: { mode: 'flexible' },
  SLIDER: { mode: 'flexible' },
  TIMELINE: { mode: 'flexible' },
  HERO_BANNER: { mode: 'flexible' },
  PILL_TAGS: { mode: 'flexible' },
  CATEGORY_STACK: { mode: 'flexible' },
  CATEGORY_SIDEBAR: { mode: 'flexible' },
  CATEGORY_FEATURE_SPLIT: { mode: 'range', min: 1, max: 5, default: 5 },
  CATEGORY_CAROUSEL: { mode: 'flexible' },
  CATEGORY_PRODUCT_ROW: { mode: 'flexible' },
  CATEGORY_PORTAL_CARDS: { mode: 'flexible' },
  // —— 区间 ——
  FOCUS_CAROUSEL_LIST: { mode: 'range', min: 1, max: 10, default: 5 },
  TAB_PANEL_SWITCH: { mode: 'flexible' },
  INTRO_CARD_GRID: { mode: 'range', min: 1, max: 3, default: 3 },
  CARD_GRID: { mode: 'range', min: 1, max: 6, default: 6 },
  HORIZONTAL_LIST: { mode: 'range', min: 1, max: 6, default: 5 },
  FEATURE_SIDE: { mode: 'range', min: 3, max: 5, default: 4 },
  ICON_GRID: { mode: 'range', min: 4, max: 8, default: 8 },
  ACCORDION: { mode: 'range', min: 1, max: 6, default: 5 },
  STATS_SHOWCASE: { mode: 'range', min: 3, max: 6, default: 4 },
  NUMBERED_FEATURES: { mode: 'range', min: 2, max: 6, default: 3 },
  ZIGZAG_FEATURE: { mode: 'range', min: 2, max: 6, default: 3 },
  CHECKLIST_FEATURES: { mode: 'range', min: 1, max: 6, default: 6 },
  CATEGORY_BENTO: { mode: 'range', min: 3, max: 5, default: 5 },
  PRODUCT_COMPARE: { mode: 'range', min: 2, max: 4, default: 3 },
  // —— 固定 ——
  DUAL_COLUMN: { mode: 'fixed', count: 2 },
  SPOTLIGHT_PANEL: { mode: 'fixed', count: 1 },
}

const DEFAULT_BEHAVIOR = { mode: 'flexible' }

/** 获取模板展示行为 */
export function getTemplateBehavior(template) {
  return TEMPLATE_BEHAVIOR[resolveTemplateKey(template)] || DEFAULT_BEHAVIOR
}

/** 固定模板的设计槽位数；弹性/区间模板返回 null */
export function getTemplateFixedCount(template) {
  const behavior = getTemplateBehavior(template)
  return behavior.mode === 'fixed' ? behavior.count : null
}

/** 区间模板的可配置范围；无则返回 null */
export function getTemplateDisplayRange(template) {
  const behavior = getTemplateBehavior(template)
  if (behavior.mode !== 'range') return null
  return { min: behavior.min, max: behavior.max, default: behavior.default ?? behavior.min }
}

/** 手动模式下可选条目上限；flexible 模板返回 null（不限） */
export function getTemplateManualMaxCount(template) {
  const behavior = getTemplateBehavior(template)
  if (behavior.mode === 'fixed') return behavior.count
  if (behavior.mode === 'range') return behavior.max
  return null
}

/** 自动模式下不限条数的模板（展示数量仍可配置，0 表示按模板舒适数量回退） */
export function isUnlimitedDisplayTemplate(template) {
  return ['SLIDER', 'TIMELINE', 'MASONRY_TEXT', 'MASONRY_COVER', 'HERO_BANNER', 'CATEGORY_PORTAL_CARDS'].includes(resolveTemplateKey(template))
}

/** 表单/新建模块时的默认展示条数 */
export function getTemplateDefaultDisplayCount(template) {
  const key = resolveTemplateKey(template)
  const range = getTemplateDisplayRange(template)
  if (range) return range.default ?? range.min
  const fixed = getTemplateFixedCount(template)
  if (fixed != null) return fixed
  return Math.max(1, getTemplateDisplayLimit(key))
}

/** 表单「显示数量」旁的提示文案 */
export function getTemplateHint(template) {
  const key = resolveTemplateKey(template)
  if (key === 'CARD_GRID') {
    return '可设置 1～6 条；电脑端初始最多展示 6 条、手机端 4 条，超出显示「查看更多」按钮。'
  }
  if (key === 'MASONRY_TEXT' || key === 'MASONRY_COVER') {
    return '可设置展示条数；电脑端初始最多展示 6 条、手机端 4 条，超出显示「查看更多」按钮。'
  }
  if (key === 'SLIDER') {
    return '可设置展示条数；可在下方设置滚动速度（慢/中/快）。'
  }
  if (key === 'TIMELINE') {
    return '可设置展示条数；超过 5 条时显示「查看更多」按钮。'
  }
  if (key === 'CATEGORY_PORTAL_CARDS') {
    return '可设置每张入口卡片内展示的下级分类数量。'
  }
  const behavior = getTemplateBehavior(template)
  if (behavior.mode === 'fixed') {
    return `该模板固定展示 ${behavior.count} 条，展示数量不可调整。`
  }
  if (behavior.mode === 'range') {
    return `可设置 ${behavior.min}～${behavior.max} 条。`
  }
  const comfort = getTemplateDisplayLimit(template)
  return `可设置展示条数，最少 1 条；建议 ${comfort} 条以内一屏展示。超出时可在模板区域内滚动。`
}

/** 旧 layout 到 template 的兼容映射 */
const LEGACY_LAYOUT_MAP = {
  GRID: 'CARD_GRID',
  LIST: 'HORIZONTAL_LIST'
}

/** 获取模板在选择器中的可见性与可选性配置 */
export function getTemplatePickerConfig(templateKey) {
  const key = resolveTemplateKey(templateKey)
  const tpl = HOME_TEMPLATES.find((t) => t.key === key)
  return { ...DEFAULT_PICKER_CONFIG, ...tpl?.picker }
}

/** 判断模板是否适用于指定数据源类型 */
export function isTemplateValidForSourceType(templateKey, sourceType) {
  if (!sourceType || !templateKey) return false
  const key = resolveTemplateKey(templateKey)
  const tpl = HOME_TEMPLATES.find((t) => t.key === key)
  return Boolean(tpl?.sourceTypes.includes(sourceType))
}

/** 获取指定数据源类型下可见的模板列表 */
export function getTemplates(sourceType) {
  if (!sourceType) return []
  return HOME_TEMPLATES
    .filter((t) => t.sourceTypes.includes(sourceType))
    .filter((t) => getTemplatePickerConfig(t.key).visible)
    .map((t) => ({
      ...t,
      selectable: getTemplatePickerConfig(t.key).selectable,
    }))
}

/** 获取指定数据源类型的默认模板 key */
export function getDefaultTemplate(sourceType) {
  return DEFAULT_BY_SOURCE[sourceType] || 'CARD_GRID'
}

/** 解析门户/配置实际使用的 template key（含旧 key 迁移）
 * 有 locale 时：localeStyles[locale].template → 默认语言 → 主表 template
 * 未传 locale 时：只用主表 template（避免编辑预览被旧 localeStyles 盖住）
 */
export function resolveTemplate(section, locale = '', defaultLocale = 'zh-CN') {
  const overlay = locale ? section?.localeStyles?.[locale]?.template : null
  const fallback = locale && defaultLocale
    ? section?.localeStyles?.[defaultLocale]?.template
    : null
  let key
  if (overlay) {
    key = overlay
  } else if (fallback) {
    key = fallback
  } else if (section?.template) {
    key = section.template
  } else if (section?.layout && LEGACY_LAYOUT_MAP[section.layout]) {
    key = LEGACY_LAYOUT_MAP[section.layout]
  } else if (section?.sourceType === 'PRODUCT_CATEGORY') {
    key = 'CATEGORY_PRODUCT_ROW'
  } else {
    key = 'CARD_GRID'
  }
  return resolveTemplateKey(key)
}

/** 判断模板是否为产品类模板 */
export function isProductTemplate(template) {
  return [
    'CATEGORY_STACK', 'CATEGORY_SIDEBAR',
    'CATEGORY_FEATURE_SPLIT', 'CATEGORY_CAROUSEL',
    'CATEGORY_BENTO', 'PRODUCT_COMPARE', 'CATEGORY_PRODUCT_ROW', 'CATEGORY_PORTAL_CARDS',
  ].includes(resolveTemplateKey(template))
}

/** 分类分块 / 侧栏 / 主推分栏（手动模式需先选一级分类） */
export function isProductCategoryBlockTemplate(template) {
  return ['CATEGORY_STACK', 'CATEGORY_SIDEBAR', 'CATEGORY_FEATURE_SPLIT'].includes(resolveTemplateKey(template))
}

/** 仅支持自动取条的产品分类模板（禁用「手动指定」） */
export const AUTO_ONLY_HOME_PRODUCT_TEMPLATES = [
  'CATEGORY_PRODUCT_ROW',
  'CATEGORY_STACK',
  'CATEGORY_SIDEBAR',
  'CATEGORY_FEATURE_SPLIT',
  'CATEGORY_PORTAL_CARDS',
]

export function isAutoOnlyHomeProductTemplate(template) {
  return AUTO_ONLY_HOME_PRODUCT_TEMPLATES.includes(resolveTemplateKey(template))
}

/** 判断模板是否为内容类模板 */
export function isContentTemplate(template) {
  return [
    'CARD_GRID', 'HORIZONTAL_LIST', 'FEATURE_SIDE', 'SLIDER',
    'MASONRY_TEXT', 'MASONRY_COVER', 'TIMELINE', 'DUAL_COLUMN', 'ICON_GRID',
    'HERO_BANNER', 'ACCORDION',
    'STATS_SHOWCASE', 'NUMBERED_FEATURES', 'SPOTLIGHT_PANEL',
    'ZIGZAG_FEATURE', 'CHECKLIST_FEATURES',
    'PILL_TAGS', 'FOCUS_CAROUSEL_LIST', 'TAB_PANEL_SWITCH', 'INTRO_CARD_GRID',
  ].includes(resolveTemplateKey(template))
}
